import React from 'react'
import Box from '@ui/Box'
import { Button, Checkbox, Modal } from 'antd'
import ShareCodeContent from '@components/ShareCode/ShareCodeContent'
import Flex from '@ui/Flex'
import { updateDoNotShowAfterPublishOnboarding } from '@api/users'
import { useQueryClient } from '@tanstack/react-query'
import routes from '@routes'

type Props = {
  open: boolean
  onClose: () => void
}

const AfterPublishPopup = ({ open, onClose }: Props) => {
  const queryClient = useQueryClient()

  return (
    <>
      <Modal
        footer={[
          <Box key="close">
            <Flex alignItems="center" justifyContent="flex-end">
              <Box mr={16}>
                <Checkbox
                  onChange={async e => {
                    await updateDoNotShowAfterPublishOnboarding(e.target.checked)
                    queryClient.invalidateQueries([routes.api.user.me])
                  }}
                >
                  Don't show this again
                </Checkbox>
              </Box>
              <Button onClick={onClose}>Close</Button>
            </Flex>
          </Box>,
        ]}
        title={<Box fontSize={22}>Your widget is ready to use! 🎉 What's next?</Box>}
        open={open}
        width={850}
        onCancel={onClose}
        maskClosable={false}
        style={{ top: 20 }}
      >
        <Box mt={26}>
          <ShareCodeContent afterPublish />
        </Box>
      </Modal>
    </>
  )
}

export default AfterPublishPopup
